import { DESKTOP_SCREEN_WIDTH, MOBILE_SCREEN_WIDTH } from "@common/constants";
import { useMediaQuery } from "react-responsive";

export const useIsTablet = () => {
    return useMediaQuery({
        minWidth: MOBILE_SCREEN_WIDTH,
        maxWidth: DESKTOP_SCREEN_WIDTH,
    });
}
